import React from "react";
import { Link } from "react-router-dom";
import { Network, Mail, Phone, MapPin, Shield, Server, Users } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <span className="text-2xl font-bold text-white">NetSyTe</span>
            <p className="text-gray-300 text-sm">
              Professionelle IT-Services und Cybersicherheit für Unternehmen.
            </p>
            <div className="flex space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <MapPin className="h-4 w-4" />
                <span>Deutschland</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Leistungen</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">IT-Infrastruktur</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">IT-Sicherheit</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Netzwerkmanagement</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">IT-Beratung</Link></li>
              <li><Link to="/cyber-risiko-check" className="hover:text-blue-400 transition-colors">CyberRisikoCheck</Link></li>
            </ul>
          </div>

          {/* Service Models */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Service-Modelle</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/service-models" className="hover:text-blue-400 transition-colors">IT-Service Flatrate</Link></li>
              <li><Link to="/service-models" className="hover:text-blue-400 transition-colors">IT-Service on Demand</Link></li>
              <li><Link to="/service-models" className="hover:text-blue-400 transition-colors">Serverwartung</Link></li>
              <li><Link to="/service-models" className="hover:text-blue-400 transition-colors">Cloud-Telefonie</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold">Kontakt</h3>
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4" />
                <span>+49 (0) 123 456 7890</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <span>info@netsyte.de</span>
              </div>
            </div>
            <div className="pt-4">
              <Link 
                to="/contact" 
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm"
              >
                Beratung anfragen
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © 2024 NetSyTe - Netzwerk System Technik. Alle Rechte vorbehalten.
          </p>
          <div className="flex space-x-6 mt-4 sm:mt-0">
            <Link to="/datenschutz" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">
              Datenschutz
            </Link>
            <Link to="/impressum" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;